import { render } from "./TrendingValueWithPopover.vue?vue&type=template&id=e3b3dbc8&scoped=true"
import script from "./TrendingValueWithPopover.vue?vue&type=script&lang=js"
export * from "./TrendingValueWithPopover.vue?vue&type=script&lang=js"

import "./TrendingValueWithPopover.vue?vue&type=style&index=0&id=e3b3dbc8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3b3dbc8"]])

export default __exports__